import React from 'react';
import { useMediaQuery } from '@mui/material';
import { FooterContainer, FooterLink } from '../RequestForm/styles';

import { Grid } from '@mui/material';

export const Footer = () => {
  const isMobile = useMediaQuery('(max-width: 992px)');
  const contactUSLink = 'https://healthfirst.org/contact';
  const webPrivacyNotice =
    'https://assets.healthfirst.org/api/item?id=pdf_267ff1120f&amp;site=healthfirst.org&amp;referrer=https%3A%2F%2Fhealthfirst.org%2Fdeveloper&amp;v=0503123056';
  const newYorkPrivacyNotice =
    'https://assets.healthfirst.org/api/item?id=pdf_53b845cf68&amp;site=healthfirst.org&amp;referrer=https%3A%2F%2Fhealthfirst.org%2Fdeveloper&amp;v=0503123056';

  const COPYRIGHT = `© ${new Date().getFullYear()} Healthfirst, Inc. All Rights Reserved`;
  return (
    <>
      <footer
        style={{
          color: 'gray',
          position: 'sticky',
          bottom: 0,
          zIndex: '2',
        }}
      >
        <FooterContainer style={{ height: isMobile ? '' : '50px' }}>
          {isMobile ? (
            <>
              <Grid
                container
                // direction="column"
                justifyContent="center"
                alignItems="center"
              >
                <Grid item>
                  <p>{COPYRIGHT}</p>
                </Grid>
                <Grid item>
                  <p>
                    <FooterLink href={contactUSLink}>Contact Us</FooterLink>
                    <FooterLink
                      href={webPrivacyNotice}
                      target="_blank"
                    >
                      Web Privacy Statement
                    </FooterLink>
                    <FooterLink
                      href={newYorkPrivacyNotice}
                      target="_blank"
                    >
                      New York Privacy Notice
                    </FooterLink>
                  </p>
                </Grid>
              </Grid>
            </>
          ) : (
            <Grid
              container
              justifyContent={'space-around'}
            >
              <Grid item>
                {/* <span>&copy; 2024 Healthfirst, Inc. All Rights Reserved</span> */}
                <span>{COPYRIGHT}</span>
              </Grid>
              <Grid
                item
                direction={'column'}
              >
                <FooterLink href={contactUSLink}>Contact Us </FooterLink>
                {/* <Divider
                  orientation="vertical"
                  variant="middle"
                  item
                /> */}
                <span>|</span>
                <FooterLink href={webPrivacyNotice}>Web Privacy Statement</FooterLink>
                {/* <Divider
                  orientation="vertical"
                  variant="middle"
                  item
                /> */}
                <span>|</span>
                <FooterLink href={newYorkPrivacyNotice}>New York Privacy Notice</FooterLink>
              </Grid>
            </Grid>
          )}
        </FooterContainer>
      </footer>
    </>
  );
};
